import searchConstants from "../_constants/searchConstants";
import searchService from "../_services/searchService";
import messagingConstants from "../_constants/messagingConstants";
import messagingService from "../_services/messagingService";
import { firestore } from "../_firebase";
import Collection from "../_collections";

/* ---------------------------------------------------
  GET CONVERSATIONS
----------------------------------------------------- */

export const getConversations = payload => dispatch => {
  // const { data, onSuccess, onError } = payload;
  messagingService
    .getConversations()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getConversationsSuccess(results));
      if (results.length < 14) {
        dispatch(changeLastResultForConversations(null));
      } else {
        dispatch(changeLastResultForConversations(lastResult));
      }
    })
    .catch(err => {
      dispatch(getConversationsSuccess([]));
      dispatch(changeLastResultForConversations(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
  GET CONVERSATIONS SUCCESS
----------------------------------------------------- */
const getConversationsSuccess = payload => ({
  type: messagingConstants.GET_CONVERSATIONS,
  payload
});
/* ---------------------------------------------------
  CLEAR CONVERSATIONS
----------------------------------------------------- */
export const clearConversations = payload => ({
  type: messagingConstants.CLEAR_CONVERSATIONS,
  payload
});

/* ---------------------------------------------------
  INITIALIZE CHAT
----------------------------------------------------- */
export const initializeChat = payload => ({
  type: messagingConstants.INITIALIZE_CHAT,
  payload
});

/* ---------------------------------------------------
  CLEAR CHAT
----------------------------------------------------- */
export const clearChat = payload => ({
  type: messagingConstants.CLEAR_CHAT,
  payload
});

/* ---------------------------------------------------
  GET CHAT USER INFORMATION
----------------------------------------------------- */

export const getChatUserInformation = payload => dispatch => {
  const unsubscribe = firestore
    .collection(Collection.USERS)
    .doc(payload)
    .onSnapshot(user => {
      const data = user.data();
      const information = {
        imageURL: data.imageURL,
        name: data.name,
        status: data.status
      };

      dispatch(getChatUserInformationSuccess(information));
    });

  return unsubscribe;
};
/* ---------------------------------------------------
  GET CHAT USER INFORMATION SUCCESS
----------------------------------------------------- */
export const getChatUserInformationSuccess = payload => ({
  type: messagingConstants.GET_CHAT_USER_INFORMATION,
  payload
});

/* ---------------------------------------------------
  LOAD UP CHAT MESSAGES
----------------------------------------------------- */
export const loadUpChatMessages = payload => dispatch => {
  const unsubscribe = firestore
    .collection(Collection.MESSAGING)
    .doc(payload)
    .collection(Collection.CHAT_MESSAGES)
    .orderBy("createdAt", "desc")
    .limit(10)
    .onSnapshot(snapshot => {
      let messages = [];
      let newMessage = false;
      snapshot.docChanges().forEach(change => {
        //added
        if (change.type === "added") {
          messages.push({ ...change.doc.data(), ...{ id: change.doc.id } });
          newMessage = true;
        }
      });
      dispatch(changeNewMessageAddedFlag(newMessage));
      dispatch(loadUpChatMessagesSuccess(messages));
      if (messages.length < 10) {
        dispatch(changeIsLastResultForChat(true));
      } else {
        dispatch(changeIsLastResultForChat(false));
      }
    });

  return unsubscribe;
};

/* ---------------------------------------------------
  LOAD UP CHAT MESSAGES SUCCESS
----------------------------------------------------- */
export const loadUpChatMessagesSuccess = payload => ({
  type: messagingConstants.LOAD_UP_CHAT_MESSAGES,
  payload
});

/* ---------------------------------------------------
  SEND MESSAGE
----------------------------------------------------- */

export const sendMessage = payload => dispatch => {
  const { messagingId, message, onSuccess, onError } = payload;
  messagingService
    .send(messagingId, message)
    .then(results => {
      dispatch(sendMessageSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
      console.log(err);
    });
};

/* ---------------------------------------------------
  SEND MESSAGE SUCCESS
----------------------------------------------------- */
export const sendMessageSuccess = payload => ({
  type: messagingConstants.SEND_MESSAGE,
  payload
});

/* ---------------------------------------------------
  UPDATE PARTICIPANT IMAGE URL
----------------------------------------------------- */

export const updateParticipantImageUrl = payload => dispatch => {
  const { messagingId, image, selectedId } = payload;
  messagingService
    .updateImageUrl(selectedId, image)
    .then(results => {
      dispatch(updateParticipantImageUrlSuccess({ selectedId, image }));
    })
    .catch(err => {
      console.log(err);
    });
};

/* ---------------------------------------------------
  UPDATE PARTICIPANT IMAGE URL SUCCESS
----------------------------------------------------- */
export const updateParticipantImageUrlSuccess = payload => ({
  type: messagingConstants.UPDATE_PARTICIPANT_IMAGE_URL,
  payload
});

/* ---------------------------------------------------
  CHANGE IS LAST RESULT FOR CHAT
----------------------------------------------------- */
const changeIsLastResultForChat = payload => ({
  type: messagingConstants.CHANGE_IS_LAST_RESULT_FOR_CHAT,
  payload
});

/* ---------------------------------------------------
  LOAD PREVIOUS MESSAGES
----------------------------------------------------- */
export const loadPreviousMessages = payload => dispatch => {
  const { lastResult, messagingId } = payload;
  messagingService
    .loadMoreMessages(lastResult, messagingId)
    .then(data => {
      const { messages, isLastResult } = data;
      dispatch(changeNewMessageAddedFlag(false));
      dispatch(loadPreviousMessagesSuccess(messages));
      dispatch(changeIsLastResultForChat(isLastResult));
    })
    .catch(err => {
      dispatch(loadPreviousMessagesSuccess([]));
      dispatch(changeIsLastResultForChat(true));
      dispatch(changeNewMessageAddedFlag(false));
    });
};

/* ---------------------------------------------------
  LOAD PREVIOUS MESSAGES SUCCESS
----------------------------------------------------- */
export const loadPreviousMessagesSuccess = payload => ({
  type: messagingConstants.LOAD_PREVIOUS_MESSAGES,
  payload
});

/* ---------------------------------------------------
  CHANGE NEW MESSAGE ADDED FLAG
----------------------------------------------------- */
const changeNewMessageAddedFlag = payload => ({
  type: messagingConstants.CHANGE_NEW_MESSAGE_ADDED_FLAG,
  payload
});

/* ---------------------------------------------------
  CHANGE LAST RESULT FOR CONVERSATIONS
----------------------------------------------------- */
const changeLastResultForConversations = payload => ({
  type: messagingConstants.CHANGE_LAST_RESULT_FOR_CONVERSATIONS,
  payload
});

/* ---------------------------------------------------
  LOAD MORE CONVERSATIONS
----------------------------------------------------- */

export const loadMoreConversations = payload => dispatch => {
  const { lastResult } = payload;
  messagingService
    .loadMoreConversations(lastResult)
    .then(response => {
      const { results, lastResult } = response;
      dispatch(loadMoreConversationsSuccess(results));
      dispatch(changeLastResultForConversations(lastResult));
    })
    .catch(err => {
      dispatch(loadMoreConversationsSuccess([]));
      dispatch(changeLastResultForConversations(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
  LOAD MORE CONVERSATIONS
----------------------------------------------------- */
const loadMoreConversationsSuccess = payload => ({
  type: messagingConstants.LOAD_MORE_CONVERSATIONS,
  payload
});



// WEBPACK FOOTER //
// ./src/_actions/messagingActions.js